import { render, staticRenderFns } from "./WPLayoutBorder.vue?vue&type=template&id=7c4328bf"
import script from "./WPLayoutBorder.vue?vue&type=script&lang=ts"
export * from "./WPLayoutBorder.vue?vue&type=script&lang=ts"
import style0 from "./WPLayoutBorder.vue?vue&type=style&index=0&id=7c4328bf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports